export const INCREMENT_ATT_COUNT = 'INCREMENT_ATT_COUNT';
export const incrementAttCount = {
    type: INCREMENT_ATT_COUNT
};

export const INCREMENT_CORRECT_COUNT = 'INCREMENT_CORRECT_COUNT';
export const incrementCorrectCount = {
    type: INCREMENT_CORRECT_COUNT
};

export const NEXT_QUESTION = 'NEXT_QUESTION';
export const nextQuestion = {
    type: NEXT_QUESTION
};